import React from "react";
import { formatPrice } from "../../../../../../utilities/formatPrice";
import localeText from "../../../../../../locale";

const EconomicCircleEarningsCard = ({
  currency,
  networkEarnings,
  monthlyChange,
  totalAccumulated,
  directCommission,
  networkCommission,
}) => (
  <div
    className="border-round-md p-3 h-full flex flex-column justify-content-between"
    style={{ border: "1px solid var(--theme-border, #EBEBEB)" }}
  >
    <div>
      <div
        className="text-xs font-semibold uppercase mb-2"
        style={{ color: "var(--theme-text-muted)" }}
      >
        {localeText("networkEarnings") || "Ganhos de rede"}
      </div>
      <div className="flex align-items-baseline gap-2">
        <div className="text-3xl font-medium mb-1" style={{ color: "var(--theme-text)" }}>
          {currency} {formatPrice(networkEarnings)}
        </div>
        <div
          className="text-sm px-2 py-1 border-round font-medium"
          style={{
            color: "var(--theme-primary)",
            backgroundColor: "color-mix(in srgb, var(--theme-primary-light) 30%, transparent)",
          }}
        >
          +{monthlyChange}% {localeText("thisMonth") || "este mês"}
        </div>
      </div>

      <div
        className="text-xs mb-2 uppercase font-medium"
        style={{ color: "color-mix(in srgb, var(--theme-text) 50%, transparent)" }}
      >
        {localeText("totalAccumulatedLifetime") || "Total acumulado (Lifetime)"}: {currency}{" "}
        {formatPrice(totalAccumulated)}
      </div>
    </div>
    <div className="" style={{ borderColor: "var(--theme-border)", color: "var(--theme-text)" }}>
      <div className="text-sm font-medium flex align-items-center justify-content-between">
        <div>{localeText("directCommission") || "Comissão direta"} </div>
        <div>
          {currency} {formatPrice(directCommission)}
        </div>
      </div>
      <div className="border-top-1 my-3" style={{ borderColor: "var(--theme-border)" }}></div>
      <div className="text-sm font-medium flex align-items-center justify-content-between">
        <div>{localeText("networkCommission") || "Comissão de rede"} </div>
        <div>
          {currency} {formatPrice(networkCommission)}
        </div>
      </div>
    </div>
  </div>
);

export default EconomicCircleEarningsCard;
